import { useLocalization } from '@magicdoor/ui';
import { Checkbox } from '~/components/common/Inputs/Checkbox';

export const PolicyCheckbox = () => {
  const { t } = useLocalization();

  return (
    <Checkbox
      checkBoxClass="shrink items-start text-sm"
      name="policy"
      checked
      required
      showLabel
      labelClass="whitespace-normal"
      label={
        <>
          {t('By signing in, I agree to the')}
          <a
            class="m-1 text-blue hover-allowed:hover:underline"
            href="https://magicdoor.com/terms-of-service"
            rel="noopener noreferrer"
            target="_blank">
            {t('Terms of service')}
          </a>
          {t('And')}
          <a
            class="ml-1 text-blue hover-allowed:hover:underline"
            href="https://magicdoor.com/privacy-policy/"
            rel="noopener noreferrer"
            target="_blank">
            {t('Privacy policy')}
          </a>
        </>
      }
    />
  );
};
